// in src/users.js
import React from 'react';
import { TextInput, SimpleForm, Create, SimpleList, List, Datagrid, EmailField, TextField, ReferenceField } from 'react-admin';
import { OnlyShowActionsList } from './FieldComponents/OnlyShowActions';
import { useMediaQuery } from '@mui/material';

//Utils
import Validators from './renderFields/validatorsFields';

export const UserTypeList = (props) => {
    // Check if the screen size is small
    const isSmall = useMediaQuery((theme) => theme.breakpoints.down('sm'));

    return (
        <List title="Perfiles" {...props} actions={<OnlyShowActionsList />}>
            {isSmall ? (
                <SimpleList
                    primaryText={record => record.name}
                />
            ) : (
                <Datagrid>
                    <TextField source="id" />
                    <TextField source="name" label="Perfil"/>
                </Datagrid>
            )}
        </List>
    );
};


export const UserTypeCreate = (props) => (
    <Create {...props}>
        <SimpleForm >
            <TextInput source="name" validate={[Validators.required]}/>
        </SimpleForm>
    </Create>
);
